import { render, staticRenderFns } from "./WeaponModContent.vue?vue&type=template&id=607d1707&lang=pug"
import script from "./WeaponModContent.vue?vue&type=script&lang=js"
export * from "./WeaponModContent.vue?vue&type=script&lang=js"
import style0 from "./WeaponModContent.vue?vue&type=style&index=0&id=607d1707&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports